import { axiosService } from "@/services/AxiosService";

/**
 * @typedef {Object} Colour
 * @property {number} id - ID
 * @property {string} name - Nome

 */

class ColoursService {
    
    path = '/colours/get-colours';
    
    constructor() {
        this.axiosInstance = axiosService.getInstance(); // Usa l'istanza di AxiosService
    }

    /**
     * Recupera la lista dei cavalli.
     * @returns {Promise<Colour[]>} - Una promessa che risolve con la lista di cavalli
     * @throws {Error} - Lancia un errore se la chiamata fallisce
     */
    async getColours() {
        try {
            const response = await this.axiosInstance.post(this.path);

            if (response.status !== 200) {
                throw new Error('Failed to fetch colours info');
            }

            /** @type {Colour[]} */
            return response.data.data?.colours;
        } catch (error) {
            console.error('Error fetching colours info:', error);
            throw error; // Rialza l'errore per gestirlo nel chiamante
        }
    }

}

export const coloursService = new ColoursService();
